module.exports = __webpack_public_path__ + "media/87.13742bf1.mp3";